<template>
    <ul class="list-inline item-touching menu_transaction b-1">
        <li v-for="filter in options" :key="filter.id">
            <a :class="filter.class" @click="select(filter.id)">
                <span :class="filter.chip">
                </span>
                {{ filter.label }}
            </a>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        /**
         * Values to filter :
         * + id : Required
         * + label: Required
         * + active: Optionnal, Boolean
         * + type: Optionnal to color chip, String, enum: default, black, primary, secondary, success, warning, error
         */
        filters: {
            required: true,
            type: Array,
            validator: (filters) => {
                let correct = true
                const types = ['default', 'black', 'primary', 'secondary', 'success', 'warning', 'error']
                filters.forEach((filter) => {
                    correct = correct && filter.hasOwnProperty('id') && filter.id !== null
                    correct = correct && filter.hasOwnProperty('label') && filter.label !== ''
                    if (filter.hasOwnProperty('active')) {
                        correct = correct && typeof filter.active === 'boolean'
                    }
                    if (filter.hasOwnProperty('type')) {
                        correct = correct && types.indexOf(filter.type) !== -1
                    }
                })
                return correct
            }
        },
        /**
         * Fitler Id of selected
         */
        selected: {
            require: false,
            default: null
        }
    },
    computed: {
        options: function () {
            return this.filters.map(filter => {
                // Button class
                filter.class = 'btn btn-default'
                if (filter.hasOwnProperty('active') && filter.active === false) {
                    filter.class = 'btn btn-default btn-disabled js-btn-disabled'
                }
                if (this.selected === filter.id) {
                    filter.class = 'btn btn-primary'
                }

                //Chip class
                filter.chip = ''
                if (filter.hasOwnProperty('type')) {
                    filter.chip = `chip chip-${filter.type}`
                }
                return filter
            })
        }
    },
    methods: {
        select: function (id) {
            /**
             * Triggers when a fitler is selected
             *
             * @property {mixed} id of the filter selected
             */
            this.$emit('selected', id)
        }
    }
}
</script>
